import { PermissionType } from '../enum/PERMISSION';

export class PermissionDto {
  id: number;
  description: string;
  permission: PermissionType;
}
